const initialState = () => ({
  isOpened: false,
  padVisit: {},
  onSuccessCallback: null,
  modalData: {
    title: '',
    description: '',
    confirmationTerm: ''
  }
});

const ACTION_KEY = 'PAD_CREATOR_VISIT_CONFIRMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { padVisit, modalData, onSuccessCallback } = action.payload;

      return {
        ...state,
        isOpened: true,
        padVisit,
        modalData,
        onSuccessCallback
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
